// @flow
import dog from './assets/hiw_dog.svg';
import tag from './assets/hiw_tag.svg';
import walker from './assets/hiw_walker.svg';

export const icons = {
  dog,
  tag,
  walker,
};
